import Vue from 'vue'
import Vuex from 'vuex'
import { getUserInfoByCookie, checkOsType, checkBrowserType } from '@/utils/utils.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      id: 0,
      jwt: ''
    },
    os_type: 'other',
    browser_type: 'other'
  },
  mutations: {
    setUser (state, value) {
      state.user = value
    },
    setOsType (state, value) {
      state.os_type = value
    },
    setBrowserType (state, value) {
      state.browser_type = value
    }
  },
  actions: {
    init (context) {
      context.commit('setUser', getUserInfoByCookie())
      context.commit('setOsType', checkOsType())
      context.commit('setBrowserType', checkBrowserType())
    }
  },
  getters: {
    isLogin (state) {
      return state.user.id > 0 && state.user.jwt !== ''
    },
    isPC (state) {
      return state.os_type === 'windows' || state.os_type === 'mac' || state.os_type === 'linux'
    }
  },
  modules: {
  }
})
